module.exports = __webpack_public_path__ + "firewall-svgrepo-com.svg";